module.exports = __webpack_public_path__ + "img/pr-1.93a534f2.png";